import { render, staticRenderFns } from "./VacancyContent.vue?vue&type=template&id=44ae2256&"
import script from "./VacancyContent.vue?vue&type=script&lang=js&"
export * from "./VacancyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports